import { NavLink, Outlet } from 'react-router-dom';

const TABS = [
  { to: '/ventes/analyse',   label: 'Analyse' },
  { to: '/ventes/lots',      label: 'Lots' },
  { to: '/ventes/commandes', label: 'Commandes' },
  { to: '/ventes/produits',  label: 'Produits' },
];

export default function SalesLayout() {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-lg font-semibold text-slate-900">Ventes</h1>
      </div>

      <nav
        className="flex gap-1 overflow-x-auto pb-px border-b border-slate-200 -mb-px"
        role="tablist"
        aria-label="Sous-sections Ventes"
      >
        {TABS.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            role="tab"
            className={({ isActive }) =>
              `shrink-0 px-3 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 rounded-t ${
                isActive
                  ? 'border-slate-800 text-slate-900'
                  : 'border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-300'
              }`
            }
          >
            {({ isActive }) => (
              <span aria-selected={isActive} role="tab">
                {label}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
